'use strict';
define([
    'angular',
    'modules/serpchecker/components/sc-link-profile/sc-link-profile.component'
], function (angular,scLinkProfile) {
    var app = angular.module('app.serpchecker.ui', []);
    app.component('scLinkProfile',scLinkProfile);
    return app;
});
